import * as mutationTypes from './types/mutation_types';

import initialState from './initialState';

export default {
  [mutationTypes.MEALS_REQUEST](state) {
    Object.assign(state, { loading: true, error: null });
  },
  [mutationTypes.MEALS_SUCCESS](state, payload) {
    Object.assign(state, { loading: false, data: payload });
  },
  [mutationTypes.MEALS_ERROR](state, payload) {
    Object.assign(state, {
      loading: false,
      data: null,
      error: payload || true,
    });
  },
  [mutationTypes.MEALS_RESET](state) {
    Object.assign(state, ...initialState);
  },
  [mutationTypes.MEALS_SELECT](state, payload) {
    Object.assign(state, { selected: payload });
  },
  [mutationTypes.MEALS_SELECT_RESET](state) {
    Object.assign(state, { selected: { title: '' } });
  },
};
